import { render, staticRenderFns } from "./InviteUsersToCompany.vue?vue&type=template&id=1c8f649a&"
import script from "./InviteUsersToCompany.vue?vue&type=script&lang=ts&"
export * from "./InviteUsersToCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports